export default "assets/images/bg-bbc26ce5.png";